/** Describes what product segment a company bleongs to */
export enum Segment {
  Shipper = 'shipper',
  Trucker = 'trucker',
}

export const checkSegmentation: (segment?: Segment, segmentation?: Segment[]) => boolean = (
  segment,
  segmentation
) => {
  if (!segment || !segmentation) {
    return false;
  }
  return segmentation.includes(segment);
};
